import { faEnvelope, faEye, faEyeSlash, faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useState } from 'react'
import './Login.scss'
import img from '../../images/lg-Rice-Dept.png'
import { useDispatch, useSelector } from 'react-redux';
import { loginAsync } from '../../store/slices/authSlice';

export default function Login() {
    const dispatch = useDispatch()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false);
    const { loading } = useSelector((state) => state.auth);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        dispatch(loginAsync({ username, password }))
    }


    return (
        <div className='container-login'>
            <div className='wrap-login'>
                <div className="text-center logo-row-top">
                    <img src={img} className="logo-top" alt="" />
                </div>
                <div className="text-center logo-row-btm">
                    <label className="font-logo-left2">S</label><label className="font-logo-left3"> mart</label>&nbsp;&nbsp;<label className="font-logo-left2">S</label><label className="font-logo-left3"> eed</label>&nbsp;&nbsp;<label className="font-logo-left2">S</label><label className="font-logo-left3"> tock</label>&nbsp;&nbsp;<label className="font-logo-left2">S</label><label className="font-logo-left3"> ystem</label>
                </div>
                <form onSubmit={e => handleSubmit(e)}>
                    <div className="row">
                        <TextField variant="outlined"
                            fullWidth
                            required
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder='Username or Email'
                            InputProps={{
                                startAdornment:
                                    <InputAdornment position="start">
                                        <FontAwesomeIcon icon={faEnvelope} className='prefix-icon-input' />
                                    </InputAdornment>
                            }} />

                    </div>
                    <div className="row">
                        <TextField variant="outlined"
                            fullWidth
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder='Password'
                            type={showPassword ? 'text' : 'password'}
                            InputProps={{
                                startAdornment:
                                    (<InputAdornment position="start">
                                        <FontAwesomeIcon icon={faLock} className='prefix-icon-input' />
                                    </InputAdornment>),
                                endAdornment: (<InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                    </IconButton>
                                </InputAdornment>),
                            }} />

                    </div>
                    <div className="row justify-content-center">
                        <button className="login100-form-btn" type='submit'>
                            {loading ? <CircularProgress color="inherit" size={25} /> : <span> Sign in</span>}
                        </button>
                    </div>
                </form>

            </div >
        </div >
    )
}
